mutation downgradeToBasic($input: DowngradeToBasicInput!) {
  downgradeToBasic(input: $input)
}
